export async function gravatarUrl(email: string, size = 40): Promise<string> {
  const normalized = email.trim().toLowerCase()
  const data = new TextEncoder().encode(normalized)
  const buffer = await crypto.subtle.digest('SHA-256', data)
  const hash = Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
  return `https://gravatar.com/avatar/${hash}?s=${size}&d=404`
}
